if (!customElements.get('favorite-products')) {
  customElements.define(
    'favorite-products',
    class FavoriteProducts extends HTMLElement {
      constructor() {
        super();

        this.availabilityCache = new Map();
        this.visibilityRequestId = 0;
        this.visibleOriginalIndexes = [];

        this.onSucursalChanged = this.onSucursalChanged.bind(this);
        this.onShopifyBlockSelect = this.onShopifyBlockSelect.bind(this);
      }

      updateControlsVisibility() {
        const controls = this.querySelector('.swiper-controls');
        if (!controls) return;

        const total = this.testimonialTrack
          ? this.testimonialTrack.querySelectorAll('.swiper-slide').length
          : 0;

        const hideControls = total <= 1;

        controls.hidden = hideControls;
        controls.style.display = hideControls ? 'none' : '';
      }

      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.testimonialsWrapper = this.querySelector('.favorite-products__testimonials');
        this.productWrapper = this.querySelector('.favorite-products__products');
        this.mediaWrapper = this.querySelector('.favorite-products__media');
        this.sectionRoot = this.closest('.section-favorite-products') || this;

        this.TestimonialSlider = false;
        this.ProductSlider = false;
        this.MediaSlider = false;

        this.productTrack = this.productWrapper?.querySelector('.swiper-wrapper') || null;
        this.testimonialTrack = this.testimonialsWrapper?.querySelector('.swiper .swiper-wrapper') || null;
        this.mediaTrack = this.mediaWrapper?.querySelector('.swiper .swiper-wrapper') || null;

        this.captureOriginalSlides();

        document.addEventListener('sucursal:changed', this.onSucursalChanged);

        if (Shopify.designMode) {
          document.addEventListener('shopify:block:select', this.onShopifyBlockSelect);
        }

        // Evita que se alcance a ver un banner que debe ocultarse mientras se
        // consulta el inventario de la sucursal seleccionada.
        this.style.visibility = 'hidden';
        this.setAttribute('aria-busy', 'true');

        this.refreshAvailability();
      }

      disconnectedCallback() {
        document.removeEventListener('sucursal:changed', this.onSucursalChanged);
        document.removeEventListener('shopify:block:select', this.onShopifyBlockSelect);
        this.destroySliders();
      }

      get layout() {
        return this.dataset.layout;
      }

      get paginationType() {
        return this.dataset.paginationType;
      }

      get paginationTypeMobile() {
        return this.dataset.paginationTypeMobile;
      }

      captureOriginalSlides() {
        this.allProductSlides = this.productTrack ? Array.from(this.productTrack.children) : [];
        this.allTestimonialSlides = this.testimonialTrack ? Array.from(this.testimonialTrack.children) : [];
        this.allMediaSlides = this.mediaTrack ? Array.from(this.mediaTrack.children) : [];
      }

      getSucursalState() {
        try {
          const raw = localStorage.getItem('sucursal_store');
          return raw ? JSON.parse(raw) : null;
        } catch (e) {
          return null;
        }
      }

      normalizeText(value) {
        return String(value || '')
          .trim()
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '');
      }

      isGiftCard(slide, apiProduct) {
        const handle = this.normalizeText(
          slide?.dataset.productHandle || apiProduct?.handle || ''
        ).replace(/\s+/g, '-');

        const title = this.normalizeText(apiProduct?.title || '');

        return handle === 'tarjetas-de-regalo' || title === 'tarjetas de regalo';
      }

      async checkSlideAvailability(slide, state) {
        const productId = String(slide?.dataset.productId || '').trim();
        const shopifyAvailable = slide?.dataset.productAvailable !== 'false';

        // Bloque sin producto o producto agotado globalmente en Shopify.
        if (!productId || !shopifyAvailable) return false;

        // Tarjetas de regalo no dependen del inventario de sucursal.
        if (this.isGiftCard(slide)) return true;

        // Si por alguna razón aún no existe sucursal, no ocultamos un producto
        // globalmente disponible. La validación correrá de nuevo al elegir tienda.
        if (!state || !state.id) return true;

        const cacheKey = `${state.id}:${productId}`;
        if (this.availabilityCache.has(cacheKey)) {
          return this.availabilityCache.get(cacheKey);
        }

        try {
          const response = await fetch(
            'https://sioconn.dislicores.com/poligonos/inventory?locationId=' +
              encodeURIComponent(state.id) +
              '&productId=' +
              encodeURIComponent(productId),
            { headers: { Accept: 'application/json' } }
          );

          if (!response.ok) throw new Error(`HTTP ${response.status}`);

          const data = await response.json();

          // Para esta sección, si el producto no regresa en inventario de la
          // sucursal, el banner completo no debe mostrarse.
          if (!Array.isArray(data) || !data.length) {
            this.availabilityCache.set(cacheKey, false);
            return false;
          }

          const apiProduct = data[0];

          if (this.isGiftCard(slide, apiProduct)) {
            this.availabilityCache.set(cacheKey, true);
            return true;
          }

          const variants = Array.isArray(apiProduct.variants) ? apiProduct.variants : [];
          const available = variants.some((variant) => Number(variant.available) > 0);

          this.availabilityCache.set(cacheKey, available);
          return available;
        } catch (error) {
          console.warn(
            '[favorite-products] No se pudo validar inventario del producto ' + productId + '.',
            error
          );

          // Un error de red no debe borrar promociones válidas.
          return true;
        }
      }

      async refreshAvailability() {
        const requestId = ++this.visibilityRequestId;
        const state = this.getSucursalState();

        try {
          const availability = await Promise.all(
            this.allProductSlides.map((slide) => this.checkSlideAvailability(slide, state))
          );

          if (requestId !== this.visibilityRequestId) return;

          const visibleIndexes = [];
          availability.forEach((isAvailable, index) => {
            if (isAvailable) visibleIndexes.push(index);
          });

          this.applyVisibleSlides(visibleIndexes);
        } finally {
          if (requestId === this.visibilityRequestId) {
            this.style.visibility = '';
            this.removeAttribute('aria-busy');
          }
        }
      }

      onSucursalChanged() {
        this.refreshAvailability();
      }
applyVisibleSlides(visibleIndexes) {
  this.destroySliders();

  this.visibleOriginalIndexes = visibleIndexes.slice();

  this.rebuildTrack(this.productTrack, this.allProductSlides, visibleIndexes);
  this.rebuildTrack(this.testimonialTrack, this.allTestimonialSlides, visibleIndexes);
  this.rebuildTrack(this.mediaTrack, this.allMediaSlides, visibleIndexes);

  const visibleCount = visibleIndexes.length;

  this.updateControlsVisibility();

  this.sectionRoot.hidden = visibleCount === 0;
  if (visibleCount === 0) return;

  const shouldEnableSlider =
    this.dataset.enableSlider === 'true' && visibleCount > 1;

  this.sectionRoot.classList.toggle('slider-enabled', shouldEnableSlider);

  if (shouldEnableSlider) {
    this.initSlider();
  } else {
    const firstTestimonial = this.testimonialTrack?.querySelector('.swiper-slide');
    if (firstTestimonial) this.updateControlsScheme(firstTestimonial);

    const firstProduct = this.productTrack?.querySelector('.swiper-slide');
    const firstMedia = this.mediaTrack?.querySelector('.swiper-slide');

    this.refreshAnimation(firstProduct);
    this.refreshAnimation(firstMedia);
    this.fixQuickviewDuplicate();
  }
}
      rebuildTrack(track, allSlides, visibleIndexes) {
        if (!track) return;

        const fragment = document.createDocumentFragment();

        visibleIndexes.forEach((index) => {
          const slide = allSlides[index];
          if (slide) fragment.appendChild(slide);
        });

        track.replaceChildren(fragment);
      }

      toggleControls(show) {
        const controls = this.querySelector('.swiper-controls');
        if (controls) controls.hidden = !show;
      }

      destroySliders() {
        [this.TestimonialSlider, this.ProductSlider, this.MediaSlider].forEach((carousel) => {
          const slider = carousel && carousel.slider;
          if (slider && !slider.destroyed && typeof slider.destroy === 'function') {
            slider.destroy(true, true);
          }
        });

        this.TestimonialSlider = false;
        this.ProductSlider = false;
        this.MediaSlider = false;
      }

      initSlider() {
        this.currentPaginationType = this.paginationType;
        this.initProductSlider();
        this.initMediaSlider();
        this.initTestimonialSlider();

        this.TestimonialSlider.slider.on('slideChange', (swiper) => {
          const { slides, activeIndex } = swiper;
          const currentSlide = slides[activeIndex];

          this.refreshAnimation(this.ProductSlider.slider.slides[activeIndex]);
          this.refreshAnimation(this.MediaSlider.slider.slides[activeIndex]);
          this.updateControlsScheme(currentSlide);

          this.ProductSlider.slider.slideTo(activeIndex);
        });

        this.ProductSlider.slider.on('slideChange', (swiper) => {
          const { activeIndex } = swiper;
          this.MediaSlider.slider.slideTo(activeIndex);
        });

        this.MediaSlider.slider.on('slideChange', (swiper) => {
          const { activeIndex } = swiper;
          this.TestimonialSlider.slider.slideTo(activeIndex);
        });

        const activeSlide = this.TestimonialSlider.slider.slides[
          this.TestimonialSlider.slider.activeIndex || 0
        ];
        if (activeSlide) this.updateControlsScheme(activeSlide);

        this.fixQuickviewDuplicate();
      }

      initProductSlider() {
        const additionModules = [FoxTheme.Swiper.EffectFade];
        const sliderOptions = {
          slidesPerView: 1,
          loop: false,
          threshold: 2,
        };

        if (this.layout === 'content-left') {
          sliderOptions.effect = 'fade';
          sliderOptions.fadeEffect = {
            crossFade: true,
          };
          sliderOptions.autoHeight = true;
        }

        this.ProductSlider = new window.FoxTheme.Carousel(this.productWrapper, sliderOptions, additionModules);
        this.ProductSlider.init();
      }

      initMediaSlider() {
        const sliderOptions = {
          slidesPerView: 1,
          loop: false,
          threshold: 2,
          allowTouchMove: false,
        };

        this.MediaSlider = new window.FoxTheme.Carousel(this.mediaWrapper.querySelector('.swiper'), sliderOptions);
        this.MediaSlider.init();
      }

      initTestimonialSlider() {
        const sliderOptions = {
          slidesPerView: 1,
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
          pagination: {
            el: this.querySelector('.swiper-pagination'),
            clickable: true,
            type: this.paginationTypeMobile,
          },
          loop: false,
          threshold: 2,
          on: {
            init: this.handleAfterInit.bind(this),
          },
        };

        this.TestimonialSlider = new window.FoxTheme.Carousel(
          this.testimonialsWrapper.querySelector('.swiper'),
          sliderOptions
        );
        this.TestimonialSlider.init();
      }

      onShopifyBlockSelect(e) {
        if (e.detail.sectionId != this.sectionId) return;
        if (!this.TestimonialSlider || !this.TestimonialSlider.slider) return;

        const originalIndex = Number(e.target.dataset.index);
        const visibleIndex = this.visibleOriginalIndexes.indexOf(originalIndex);

        if (visibleIndex >= 0) {
          this.TestimonialSlider.slider.slideTo(visibleIndex);
        }
      }

      updateControlsScheme(activeSlide) {
        if (this.testimonialsWrapper && activeSlide) {
          const classesToRemove = Array.from(this.testimonialsWrapper.classList).filter((className) =>
            className.startsWith('color-')
          );
          classesToRemove.forEach((className) => this.testimonialsWrapper.classList.remove(className));
          const colorScheme = activeSlide.dataset.colorScheme;
          if (colorScheme) this.testimonialsWrapper.classList.add(colorScheme);
        }
      }

      handleAfterInit() {
        // Fix active bullet not transition on the first time.
        const activeBullet = this.querySelector('.swiper-pagination-bullet-active');

        if (activeBullet) {
          activeBullet.classList.remove('swiper-pagination-bullet-active');
          activeBullet.offsetHeight; // Trigger reflow.
          activeBullet.classList.add('swiper-pagination-bullet-active');
        }
      }

      refreshAnimation(activeSlide) {
        if (!activeSlide) return;
        activeSlide.querySelectorAll('motion-element').forEach((motionEl) => {
          setTimeout(() => {
            motionEl && motionEl.refreshAnimation();
          });
        });
      }

      fixQuickviewDuplicate() {
        let modalIds = [];
        Array.from(this.querySelectorAll('quick-view-modal')).forEach((modal) => {
          const modalID = modal.getAttribute('id');
          if (modalIds.includes(modalID)) {
            modal.remove();
          } else {
            modalIds.push(modalID);
          }
        });
      }
    }
  );
}
